export function calculateTotalPagesCount(
  totalItems?: number,
  itemsPerPage?: number,
): number {
  if (totalItems && itemsPerPage) {
    return Math.ceil(totalItems / itemsPerPage);
  }

  return 1;
}
